module.exports = __webpack_public_path__ + "img/hall_4.ac635d59.jpg";